import React from 'react'
import css from './Inspect.module.css'
import { Review } from 'hhsoig-design-system-core'
import { fugitive_names, races } from 'hotline_complaint_choices'
import {
  dateToString,
  formatAddress,
  formatAttachedFiles,
  formatHeight,
  formatPersonName,
  formatReviewString,
  formatWeight
} from '../../utilities'
import { Divider } from '../divider'
import { PrintReview } from '../PrintReview'
import { nameLabel } from '../../strings/labels'

export const InspectFugitive = ({ goBackToPage, pages, values }) => {
  const fugitive_sighting = [
    {
      heading: 'Fugitive',
      field_name: 'fugitive_name',
      value: formatReviewString(fugitive_names[values.fugitive_name].display)
    },
    {
      heading: 'Last known location',
      field_name: 'location_address',
      value: formatAddress(values.location_address)
    },
    {
      heading: 'Date last at location',
      field_name: 'location_date',
      value: dateToString(values.location_date)
    }
  ]

  const fugitive_description = [
    {
      heading: 'Eye color',
      field_name: 'eye_color',
      value: formatReviewString(values.eye_color)
    },
    {
      heading: 'Hair color/style',
      field_name: 'hair_color',
      value: formatReviewString(values.hair_color)
    },
    {
      heading: 'Race',
      field_name: 'race',
      value: formatReviewString(races[values.race])
    },
    {
      heading: 'Age',
      field_name: 'age',
      value: formatReviewString(values.age.toString())
    },
    {
      heading: 'Height',
      field_name: 'height',
      value: formatReviewString(
        values.height && formatHeight(values.height, values.measurement_unit)
      )
    },
    {
      heading: 'Weight',
      field_name: 'weight',
      value: formatReviewString(
        values.weight && formatWeight(values.weight, values.measurement_unit)
      )
    },
    {
      heading: 'Language or accent',
      field_name: 'language_accent',
      value: formatReviewString(values.language_accent)
    },
    {
      heading: 'Clothing',
      field_name: 'clothing',
      value: formatReviewString(values.clothing)
    },
    {
      heading: 'Tattoos or scars',
      field_name: 'tattoos_scars',
      value: formatReviewString(values.tattoos_scars)
    },
    {
      heading: 'Vehicle',
      field_name: 'vehicle',
      value: formatReviewString(values.vehicle)
    },
    {
      heading: 'Confidence level',
      field_name: 'confidence_level',
      value: formatReviewString(values.confidence_level.toString())
    },
    {
      heading: 'Additional information',
      field_name: 'additional_information',
      value: formatReviewString(values.additional_information)
    }
  ]

  const attachments = [
    {
      heading: 'Attached files',
      field_name: 'evidence_description',
      value: formatAttachedFiles(values.documents)
    },
    {
      heading: 'Evidence description',
      field_name: 'evidence_description',
      value: formatReviewString(values.evidence_description)
    }
  ]

  const contact_information = [
    {
      heading: nameLabel,
      field_name: 'first_name',
      value: formatReviewString(
        formatPersonName(values.first_name, values.last_name)
      )
    },
    {
      heading: 'Phone',
      field_name: 'phone',
      value: formatReviewString(values.phone)
    },
    {
      heading: 'Email',
      field_name: 'email',
      value: formatReviewString(values.email)
    }
  ]

  const findPageIdOfField = name => {
    let page
    page = pages.find(p => p.fields.some(f => f.name === name))
    if (!page) {
      // if page not found, search conditional fields
      page = pages.find(p =>
        p.fields.some(fld => {
          let conditionalFld
          if (fld.conditionals) {
            conditionalFld = fld.conditionals.find(c =>
              c.fields.some(f => f.name === name)
            )
            return conditionalFld ? true : false
          } else {
            return false
          }
        })
      )
    }
    return page ? page.id : null
  }

  // Create and return a <Review> tag for each detail object in 'details'.
  // The detail objects are defined above, and have 3 elements:
  // heading, field_name, value
  const iterateDetails = details => {
    return details.map((detail, i) => {
      const additionalProps = detail.omitEdit
        ? {}
        : {
            onEditClick: () => {
              goBackToPage(findPageIdOfField(detail.field_name))
            },
            editHref: 'javascript:void(0)'
          }
      return (
        <Review
          className={css.reviewContent}
          key={`${detail.field_name}_${i}`}
          heading={detail.heading}
          {...additionalProps}
        >
          {detail.value}
        </Review>
      )
    })
  }

  return (
    <div data-testid="review-complaint">
      <h1 className="form-pg-title">Your submission summary</h1>
      <p className="ds-text">
        Before you submit, make sure you check your information and save or
        print a copy for your records.
      </p>
      <h2>Fugitive sighting details</h2>
      {iterateDetails(fugitive_sighting)}

      <h2>Description</h2>
      {iterateDetails(fugitive_description)}

      <h2>Attachments</h2>
      {iterateDetails(attachments)}

      <h2>Your contact information</h2>
      {iterateDetails(contact_information)}

      <PrintReview className={css.printReview} />
      <Divider />
    </div>
  )
}
